import {forEach, length} from 'ramda';

/**
 *
 * @param {string} selector
 * @returns
 */
export default async function initProductSubscribe(selector) {
    const subscribeButtons = document.querySelectorAll(selector);
    const noButtons = length(subscribeButtons) === 0;

    if (noButtons) return;

    const {default: createSubscribtion} = await import('../functions/createSubscribtion.js');

    forEach(createSubscribtion, subscribeButtons)
}
